import { render, staticRenderFns } from "./OzWallCard.vue?vue&type=template&id=eea84ede&scoped=true&"
import script from "./OzWallCard.vue?vue&type=script&lang=ts&"
export * from "./OzWallCard.vue?vue&type=script&lang=ts&"
import style0 from "./OzWallCard.vue?vue&type=style&index=0&id=eea84ede&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea84ede",
  null
  
)

export default component.exports